import React from "react";
import { ErrorRenderer, MutationForm } from "~/components/forms/MutationForm";
import { ValueRenderer } from "~/components/forms/ValueContext";
import { ChargeFormFieldValues, FormProps } from "./types";
import { ChargeFormFields } from "./ChargeFormFields";
import { ChargeFormApiProvider } from "./chargeFormProviders/ChargeFormApi";
import { useEditInvoiceChargeMutation } from "../project-charge-form-old/editCharge.hotchoc.generated";
import { buildChargeMutation } from "./functions/buildChargeMutation";
import { ValidationResponse } from "~/gql/types";

export const ChargeForm: React.FC<FormProps> = ({
  charge,
  initialValues,
  onSaved,
  onCancel,
}) => {
  const [doEditCharge] = useEditInvoiceChargeMutation();

  const handleSubmit = async (
    values: ChargeFormFieldValues
  ): Promise<ValidationResponse> => {
    const input = buildChargeMutation(values, charge!);

    const res = await doEditCharge({ variables: { input } });

    return res?.data?.projectCharges?.editProjectCharge as ValidationResponse;
  };

  const onSuccess = () => {
    onSaved();
  };

  return (
    <MutationForm
      onSuccess={onSuccess}
      runMutation={handleSubmit}
      initialValues={initialValues}
      allowPristineSubmit
    >
      <ValueRenderer
        render={(values) => (
          <ErrorRenderer
            render={(error) => (
              <ChargeFormApiProvider
                charge={charge!}
                values={values as ChargeFormFieldValues}
              >
                <ChargeFormFields
                  error={error}
                  values={values}
                  onCancel={onCancel}
                />
              </ChargeFormApiProvider>
            )}
          />
        )}
      />
    </MutationForm>
  );
};
